import _ from 'lodash'

export function mapObjectKey(obj, map)  {
  let result = {}
  _.forIn(obj, (value, key) => {
    let newKey = map[key]
    if (newKey) {
      Object.assign(result, { [newKey]: value })
    } else {
      Object.assign(result, { [key]: value })
    }
  })
  return result
}
